var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconC1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.96,
    height: 64.96,
    viewBox: "0 0 64.96 64.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:#fff;}.a{stroke:#0a53a6;stroke-width:2px;}.b{fill:#50b848;}.c{fill:#0a53a6;}.e{stroke:none;}.f{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 32.48,
    cy: 32.48,
    r: 32.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 32.48,
    cy: 32.48,
    r: 31.48
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.828 15.533)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4956.562,3567.16a5.186,5.186,0,1,0-5.187,5.187,5.2,5.2,0,0,0,5.187-5.187",
    transform: "translate(-4945.42 -3551.245)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M4943.33,3430.934a3.678,3.678,0,0,0-.777-.266,2.17,2.17,0,0,0-2.058-1.484h-.266a1.069,1.069,0,0,0-1.054,1.044v2.262a1.076,1.076,0,0,0,1.054,1.044h.266a2.157,2.157,0,0,0,1.975-1.28,1.039,1.039,0,0,1,.8.982v7.257a8.362,8.362,0,0,1-16.724,0v-7.277a1.04,1.04,0,0,1,.8-.983,2.157,2.157,0,0,0,1.975,1.28h.266a1.071,1.071,0,0,0,1.055-1.044v-2.252a1.078,1.078,0,0,0-1.055-1.044h-.266a2.177,2.177,0,0,0-2.057,1.484,3.7,3.7,0,0,0-.777.266,2.443,2.443,0,0,0-1.485,2.282v7.256a9.908,9.908,0,0,0,9.129,9.866v6.182a8.362,8.362,0,1,1-16.723,0v-5.527a5.946,5.946,0,1,0-1.535,0v5.547a9.9,9.9,0,1,0,19.794,0v-6.182a9.908,9.908,0,0,0,9.129-9.866v-7.267a2.418,2.418,0,0,0-1.464-2.282m-2.609,1v-1.177a.636.636,0,0,1,.409.593.623.623,0,0,1-.409.584m-11.617-1.177v1.177a.638.638,0,0,1-.409-.594.61.61,0,0,1,.409-.583m-16.866,14.328a4.411,4.411,0,1,1,4.411,4.411,4.411,4.411,0,0,1-4.411-4.411",
    transform: "translate(-4910.692 -3429.173)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M4950.837,3564.3a2.323,2.323,0,1,0-2.323,2.323,2.328,2.328,0,0,0,2.323-2.323",
    transform: "translate(-4942.557 -3548.381)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M4943.33,3430.934a3.678,3.678,0,0,0-.777-.266,2.17,2.17,0,0,0-2.058-1.484h-.266a1.069,1.069,0,0,0-1.054,1.044v2.262a1.076,1.076,0,0,0,1.054,1.044h.266a2.157,2.157,0,0,0,1.975-1.28,1.039,1.039,0,0,1,.8.982v7.257a8.362,8.362,0,0,1-16.724,0v-7.277a1.04,1.04,0,0,1,.8-.983,2.157,2.157,0,0,0,1.975,1.28h.266a1.071,1.071,0,0,0,1.055-1.044v-2.252a1.078,1.078,0,0,0-1.055-1.044h-.266a2.177,2.177,0,0,0-2.057,1.484,3.7,3.7,0,0,0-.777.266,2.443,2.443,0,0,0-1.485,2.282v7.256a9.908,9.908,0,0,0,9.129,9.866v6.182a8.362,8.362,0,1,1-16.723,0v-5.527a5.946,5.946,0,1,0-1.535,0v5.547a9.9,9.9,0,1,0,19.794,0v-6.182a9.908,9.908,0,0,0,9.129-9.866v-7.267a2.418,2.418,0,0,0-1.464-2.282m-2.609,1v-1.177a.636.636,0,0,1,.409.593.623.623,0,0,1-.409.584m-11.617-1.177v1.177a.638.638,0,0,1-.409-.594.61.61,0,0,1,.409-.583m-16.866,14.328a4.411,4.411,0,1,1,4.411,4.411,4.411,4.411,0,0,1-4.411-4.411",
    transform: "translate(-4910.691 -3429.173)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconC1);
export default __webpack_public_path__ + "static/media/icon-c-1.25f33a52.svg";
export { ForwardRef as ReactComponent };